<div class="modal-content">
  <div class="modal-header">
    <div class="modal-header-left" style="font-size: large; font-weight: bold">
    </div>
    <div class="modal-header-right">
      <button type="button" class="close" (click)="close()">
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="modal-body-header d-flex position-relative" style="right: 4px; flex-direction: column;">
      <div class="position-relative">
        <i class="icon-location" [ngStyle]="{'color': getIconColor()}" style="font-size: 4rem;"></i>
        <a [href]="editLink" [ngStyle]="{'color': getIconColor()}" target="_blank" routerLinkActive="router-link-active" class="position-absolute pin-id" style="top: 45%; transform: translate(-50%, -50%);" [ngStyle]="{ 'left': getIdPosition(pinId)}">{{ pinId }}</a>
      </div>
      <span class="marker-title"><a [href]="editLink" target="_blank" [ngStyle]="{'color': getIconColor()}" routerLinkActive="router-link-active">{{ form.value.Name }}</a></span>
    </div>
    <div class="my-2 description-body">
      <h3 class="description-title">{{mapReportData?.DescriptionField ? mapReportData.DescriptionField.Name:"Description"}}</h3>
      <p>{{ form.value.Description }}</p>
    </div>
    <div class="my-2 description-body">
      <h3 class="description-title">{{ mapReportData?.PrimaryDescriptionField ? mapReportData.PrimaryDescriptionField.Name : 'Primary Description' }}</h3>
      <p>{{ form.value.PrimaryDescription }}</p>
    </div>
    <div class="my-2 description-body">
      <h3 class="description-title">{{ mapReportData?.SecondaryDescriptionField ? mapReportData.SecondaryDescriptionField.Name :'Secondary Description' }}</h3>
      <p>{{ form.value.SecondaryDescription }}</p>
    </div>
    <div class="d-flex mb-3 mt-1">
      <div class="w-50 botton-body" style="border-right: 0.5px solid rgb(0 0 0 / 43%);">
        <h3 class="bottom-body-title">Latitude</h3>
        <span class="bottom-body-text" [title]="form.value.Latitude | number: '0.8-8'">{{ form.value.Latitude | number: '0.8-8' }}</span>
      </div>
      <div class="w-50 botton-body">
        <h3 class="bottom-body-title">Longitude</h3>
        <span class="bottom-body-text" [title]="form.value.Longitude | number: '0.8-8'">{{ form.value.Longitude | number: '0.8-8' }}</span>
      </div>
    </div>
  </div>
</div>